module.exports = __webpack_public_path__ + "static/media/carroESeguro.65357e4a.png";